import { DateTime } from 'luxon';
import { TicketTypeProps } from './types';

export const sortTicketTypes = (ticketTypes: TicketTypeProps[]) => {
	// Copy before sorting — the input is React Query's selected array; sorting it in place would mutate
	// cached data.
	return [...ticketTypes].sort((a, b) => {
		if (a.orderIndex < b.orderIndex) return -1;
		if (a.orderIndex > b.orderIndex) return 1;
		return a.iD - b.iD;
	});
};

/**
 * Returns a compact on-sale status string for a ticket type.
 * Includes the full year so the user doesn't have to guess which year.
 * Examples: "On sale", "On Sale · Ends Dec 12, 2024", "Off sale · starts Jan 5, 2025", "Not visible".
 */
export const formatCompactStatus = (
	sellingTime: string | undefined,
	offSellingTime: string | undefined,
	timezone: string,
	visible: boolean
): string => {
	if (!visible) return 'Not visible';
	if (!sellingTime) return 'On sale';
	try {
		const now = DateTime.now().setZone(timezone);
		const startDate = DateTime.fromISO(sellingTime, { zone: 'UTC' }).setZone(timezone);
		const endDate = offSellingTime ? DateTime.fromISO(offSellingTime, { zone: 'UTC' }).setZone(timezone) : null;

		if (startDate < now) {
			return endDate ? `On Sale · Ends ${endDate.toFormat('MMM d, yyyy')}` : 'On sale';
		}
		return `Off Sale · Starts ${startDate.toFormat('MMM d, yyyy')}`;
	} catch {
		return 'On sale';
	}
};
